import React from "react";
import Layout from "../../components/layout";

const Geolocationsetup = () => {
  return <>Geolocationsetup</>;
};

export default Geolocationsetup;
